import { render, staticRenderFns } from "./topbar-user-notifications.vue?vue&type=template&id=382c29d7&scoped=true"
import script from "./topbar-user-notifications.vue?vue&type=script&lang=js"
export * from "./topbar-user-notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382c29d7",
  null
  
)

export default component.exports